export default "__VITE_ASSET__DH2r7K6u__"